import Cookies from 'universal-cookie';

const cookies = new Cookies();

const getOptanonConsentCookie = (): string | null => {
    try {
        const value = cookies.get('OptanonConsent') as string | undefined;
        return typeof value === 'string' ? decodeURIComponent(value) : null;
    } catch {
        return null;
    }
};

const parseGroupsFromCookie = (cookieValue: string): string[] => {
    const match = cookieValue.match(/groups=([^&]+)/);
    if (!match) return [];
    return match[1]
        .split(',')
        .filter(Boolean)
        .map((group) => {
            const [id, value] = group.split(':');
            return value === '1' ? id : null;
        })
        .filter((id): id is string => id !== null);
};

const ANALYTICS_GROUP = 'C0002'; // Performance Cookies (Amplitude, GA)
const BRAZE_GROUP = 'C0003'; // Functional Cookies (Braze)

const getActiveGroups = (): string[] => {
    if (typeof window === 'undefined') return [];

    const cookie = getOptanonConsentCookie();
    if (cookie) {
        return parseGroupsFromCookie(cookie);
    }
    return [];
};

const hasConsentLoaded = (): boolean => {
    if (typeof window === 'undefined') return false;
    return !!getOptanonConsentCookie();
};

export const ConsentService = {
    hasLoaded: (): boolean => hasConsentLoaded(),
    getConsentState: () => {
        const groups = getActiveGroups();
        return {
            analytics: groups.includes(ANALYTICS_GROUP),
            braze: groups.includes(BRAZE_GROUP),
        };
    },
};
